<div
    id="workspace-container"
    class="workspace"
    [ngStyle]="styleAttributes"
    appWidgetDragTarget
    (dragOver)="onDragOver($event)"
>
    @for (widget of widgets; track widget.id) {
        <app-widget-on-board
            [clientCode]="clientCode ?? ''"
            [widgetConfig]="widget"
            [mode]="mode"
            [dashboardId]="dashboardId"
            [isWorkspaceGlobal]="isGlobal"
            [isManagingWidget]="isManagingWidget"
            [useNewLegend]="useNewLegend"
            [dashboard]="dashboard"
            [entitlements]="entitlements"
            [user]="user"
            [fuzzyDates]="ccFuzzyDates"
            (unselectAllWidgets)="unselectAllWidgets()"
            (workspaceStateChange)="onWorkspaceStateChange($event)"
        >
        </app-widget-on-board>
    }
</div>

@if (showSlowDataApproval) {
    <ddv-slow-data-approval
        [clientCode]="clientCode"
        [selectedDate]="dateToCheckSlowness"
        [fuzzyDates]="ccFuzzyDates"
        (approved)="onSlowDataResponse()"
    >
    </ddv-slow-data-approval>
}
